"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _emotion = require("emotion");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var cellStates = _interopRequireWildcard(require("../cellStates"));

var shapes = _interopRequireWildcard(require("../shapes"));

var styles = _interopRequireWildcard(require("./documentCellStyles"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  border: none;\n  outline: none;\n  padding: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var cellStyle = (0, _emotion.css)(_templateObject());

var DocumentCellEditor =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(DocumentCellEditor, _PureComponent);

  function DocumentCellEditor() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DocumentCellEditor);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DocumentCellEditor)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "focusRef", (0, _react.createRef)());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (event) {
      var onChange = _this.props.onChange;
      onChange(event.target.value);
    });
    return _this;
  }

  (0, _createClass2.default)(DocumentCellEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focusRef.current && this.focusRef.current.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          columnIndex = _this$props.columnIndex,
          editing = _this$props.editing,
          rowIndex = _this$props.rowIndex,
          style = _this$props.style,
          onBlur = _this$props.onBlur;
      var className = styles.getClassName(columnIndex, rowIndex, cellStates.editing);
      return _react.default.createElement("div", {
        className: className,
        style: style
      }, _react.default.createElement("input", {
        className: cellStyle,
        ref: this.focusRef,
        type: "text",
        value: editing.value,
        onBlur: onBlur,
        onChange: this.onChange
      }));
    }
  }]);
  return DocumentCellEditor;
}(_react.PureComponent);

exports.default = DocumentCellEditor;
(0, _defineProperty2.default)(DocumentCellEditor, "propTypes", {
  columnIndex: _propTypes.default.number.isRequired,
  editing: shapes.editing.isRequired,
  rowIndex: _propTypes.default.number.isRequired,
  style: _propTypes.default.objectOf(_propTypes.default.any),
  onBlur: _propTypes.default.func.isRequired,
  onChange: _propTypes.default.func.isRequired
});